"use client";

import PropTypes from "prop-types";
import classNames from "classnames";

import IndividualSignupForms from "components/signup-forms/individual-form";
import CorporateForm from "components/signup-forms/corporate-form";
import InitialPageLoadGtmEvent from "components/gtm-load-events/initialPageLoadEvents";

import styles from "./styles.module.css";

const SignupTabWrapper = ({ signupType }) => {
  const tabIndividualClass = classNames({
    [styles.tab]: true,
    [styles.tabselected]: signupType === "individual",
  });

  const tabcorporateClass = classNames({
    [styles.tab]: true,
    [styles.tabselected]: signupType === "corporate",
  });

  return (
    <div>
      <InitialPageLoadGtmEvent
        pageNameForSearchId="signup"
        pageType={signupType === "individual" ? "bireysel-kayit" : "kurumsal-kayit"}
      />
      <div className={styles.tabList}>
        <a href="/uye-ol/bireysel/" className={tabIndividualClass}>
          Bireysel Üyelik
        </a>
        <a href="/uye-ol/kurumsal/" className={tabcorporateClass}>
          Kurumsal Üyelik
        </a>
      </div>
      <div className={styles.formsWrapper}>
        {signupType === "individual" ? <IndividualSignupForms /> : <CorporateForm />}
      </div>
    </div>
  );
};

SignupTabWrapper.propTypes = {
  signupType: PropTypes.string,
};

export default SignupTabWrapper;
